const MICROSOFT_OAUTH_AUTHORIZE_URL =
  'https://login.microsoftonline.com/common/oauth2/v2.0/authorize';

const MICROSOFT_CLIENT_ID =
  import.meta.env.VITE_MICROSOFT_CLIENT_ID || '6b3594b6-727a-4dee-8bd4-95cb02cb64c1';

// Azure redirect — must stay the n8n webhook that exchanges the code for tokens.
const MICROSOFT_REDIRECT_URI =
  import.meta.env.VITE_MICROSOFT_REDIRECT_URI ||
  'https://n8n.hireportal.ai/webhook/microsoft_callback';

/** Optional: n8n should HTTP-redirect the user's browser here after saving tokens. */
export const getMicrosoftOAuthSuccessUrl = () => {
  const configured = import.meta.env.VITE_MICROSOFT_OAUTH_SUCCESS_URL;
  if (configured) return configured;
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/integrations/microsoft/callback`;
  }
  return null;
};

const MICROSOFT_OAUTH_SCOPE =
  'Calendars.ReadWrite OnlineMeetings.ReadWrite User.Read offline_access';

/**
 * Build Microsoft OAuth authorize URL. `state` is the user_profiles.id so the
 * n8n callback can associate tokens with the correct account.
 */
export const buildMicrosoftTeamsOAuthUrl = (userProfileId) => {
  if (!userProfileId) return null;

  const params = new URLSearchParams({
    client_id: MICROSOFT_CLIENT_ID,
    response_type: 'code',
    redirect_uri: MICROSOFT_REDIRECT_URI,
    scope: MICROSOFT_OAUTH_SCOPE,
    state: String(userProfileId),
    prompt: 'consent',
  });

  return `${MICROSOFT_OAUTH_AUTHORIZE_URL}?${params.toString()}`;
};
